import IndividualTable from "../../../IndividualTable";
import { sampleData } from "../../sampleData";

const Distance30 = () => {
  return <IndividualTable matchType={"PRE"} gender="M" event="30" subTitle="Zamby" data={sampleData} topRankCount="16" />;
};
export default Distance30;
